import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { NgHttpLoaderModule } from 'ng-http-loader';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppInjectorService } from './app-injector.service';
import { LayoutModule } from './layout/layout.module';
import { FrameworkModule } from './framework/framework.module';
import { FeaturesCommonModule } from './features-common/features-common.module';
import { FeaturesModule } from './features/features.module';
import { CrossCuttingModule } from './framework/crosscutting/crosscutting.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { NgxEchartsModule } from 'ngx-echarts';
import { PortalModule } from '@angular/cdk/portal';
import { InjectableRxStompConfig, RxStompService, rxStompServiceFactory } from '@stomp/ng2-stompjs';
import { WsStompConfig } from './ws-stomp.config';
import { CookieService } from 'ngx-cookie-service';
import { ConsumersModule } from './features/consumers/consumers.module';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    PortalModule,
    AppRoutingModule,
    LayoutModule,
    NgHttpLoaderModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FrameworkModule,
    FeaturesCommonModule,
    FeaturesModule,
    CrossCuttingModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot({
      autoDismiss:true,
      maxOpened: 3,
      preventDuplicates: true
    }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    ConsumersModule,

  ],
  providers: [CookieService,{ provide: LocationStrategy, useClass: HashLocationStrategy }, {
    provide: InjectableRxStompConfig,
    useValue: WsStompConfig
  },
    {
      provide: RxStompService,
      useFactory: rxStompServiceFactory,
      deps: [InjectableRxStompConfig]
    }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {
  constructor(injector: Injector) {
    AppInjectorService.getInstance().setInjector(injector);
  }
}
